// Faction-aware диспетчер для Действий. Используется как из phases.js
// (нормальный розыгрыш Действия в Ф3), так и из Глобал-абилок В.1.c-2:
//   - Офицер связи (line 1) — играет произвольную карту из руки.
//   - Офицер связи (line 2) — играет копию последнего разыгранного Действия.
//
// Вынесено в отдельный модуль, чтобы избежать циклических импортов.

import { resolveAction as deusResolveAction } from './deus/actions.js';
import { resolveAction as synResolveAction } from './syntetics/actions.js';
import { resolveAction as glbResolveAction } from './global/actions.js';

// Дисптчер. Возвращает то, что вернёт ресолвер (объект ok/reason/...).
// В.1.f-1: 5-й аргумент opts (для Действий с расширенным выбором цели).
export function resolveAnyAction(state, playerIdx, cardId, target = null, opts = {}) {
  if (typeof cardId === 'string' && cardId.startsWith('syn_')) {
    return synResolveAction(state, playerIdx, cardId, target, opts);
  }
  if (typeof cardId === 'string' && cardId.startsWith('glb_')) {
    return glbResolveAction(state, playerIdx, cardId, target, opts);
  }
  return deusResolveAction(state, playerIdx, cardId, target, opts);
}

// Записать факт «последнего разыгранного Действия» — нужен Офицеру связи.
// Вызывается ВЕЗДЕ, где Action уходит в discard после resolveAnyAction.
export function rememberLastAction(state, ownerIdx, cardId) {
  state.lastActionPlayed = { cardId, ownerIdx };
}
